export interface ColoringBookImage {
  readonly id: string
  readonly name: string
  readonly path: string
}

export const COLORING_BOOK_IMAGES: readonly ColoringBookImage[] = [
  { id: 'dinosaur', name: 'Dinosaur', path: '/coloring-book/dinosaur.svg' },
  { id: 'butterfly', name: 'Butterfly', path: '/coloring-book/butterfly.svg' },
  { id: 'cat', name: 'Cat', path: '/coloring-book/cat.svg' },
  { id: 'rocket', name: 'Rocket', path: '/coloring-book/rocket.svg' },
  { id: 'spaceship', name: 'Spaceship', path: '/coloring-book/spaceship.svg' },
  { id: 'car', name: 'Car', path: '/coloring-book/car.svg' },
  { id: 'truck', name: 'Truck', path: '/coloring-book/truck.svg' },
] as const
